import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { AbstractFormFieldComponent } from '../../abstract-form-field.component';
import { NumberFormField } from '../../form-field.model';

@Component({
  selector: 'iot-platform-ui-form-number-field',
  imports: [
    FlexLayoutModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    TranslatePipe,
    MatTooltipModule,
    MatProgressSpinnerModule,
    FormsModule,
    NgClass,
    NgTemplateOutlet
  ],
  templateUrl: './form-number-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: '../../form-field/form-field.component.scss'
})
export class FormNumberFieldComponent extends AbstractFormFieldComponent<NumberFormField> {}
